import { useMemo } from "react";
import { IControlStyles, useControlStyles } from "../../../assets/layouts";
import { GRID_ACTION_TYPES } from "../../../assets/types";
import { VfxLib } from "../../../assets/vfx";
import Control from "../../../assets/vfx/controls/control";
import { CommunityNeighborhoodDto } from "../../../services/dto";

interface Props {
  data: CommunityNeighborhoodDto[];
  loading: boolean;
  isCommunityDeactive: boolean | undefined;
  controlStyles?: IControlStyles;
  onCustomEvent: (actionType: string, dataId: string) => void;
}

export const CommunityNeighborhoodPage = (props: Props) => {
  const styles = props.controlStyles ?? useControlStyles();
  const actionButtons = useMemo(() => [VfxLib.datagridActionButtons({ datagridStyles: styles }).edit], [styles]);

  return (
    <Control.DataGrid
        dataId="id"
        height="55vh"
        cols={[
          { data: "name", title: "Name", visible: true, columnType: "text", alignment: "left", width: "25%" },
          { data: "zipCodes", title: "ZIP Codes", visible: true, columnType: "custom", alignment: "left", width: "25%", customCell: (zipCodes: string[]) => zipCodes?.join(", ") ?? "" },
        ]}
        actionCol={{ data: "id", title: "Action", visible: true, columnType: "action", alignment: "right", width: "100px", controlStyles: styles, actionButtons }}
        onCustomEvent={props.onCustomEvent}
        data={props.data}
        totalRecords={props.data.length}
        loading={props.loading}
        uiOptions={{
          title: "Neighborhoods",
          primaryAction: !props.isCommunityDeactive
            ? {
                text: "New Neighborhood",
                icon: "bi bi-plus-lg",
                onClick: () =>
                  props.onCustomEvent(GRID_ACTION_TYPES.NEW, ""),
              }
            : undefined,
        }}
      />
  );
};
